var map = {
	"./badge.png": "./app/assets/images/competitions/digital_art/badge.png",
	"./badgeWithText.png": "./app/assets/images/competitions/digital_art/badgeWithText.png",
	"./categories/sponsors/celsys.png": "./app/assets/images/competitions/digital_art/categories/sponsors/celsys.png",
	"./categories/sponsors/huion.png": "./app/assets/images/competitions/digital_art/categories/sponsors/huion.png",
	"./categories/sponsors/marmoset.png": "./app/assets/images/competitions/digital_art/categories/sponsors/marmoset.png",
	"./categories/sponsors/paintable.png": "./app/assets/images/competitions/digital_art/categories/sponsors/paintable.png",
	"./categories/sponsors/pencilkings.png": "./app/assets/images/competitions/digital_art/categories/sponsors/pencilkings.png",
	"./categories/sponsors/tonytextures.png": "./app/assets/images/competitions/digital_art/categories/sponsors/tonytextures.png",
	"./judges/kirill_tokarev.png": "./app/assets/images/competitions/digital_art/judges/kirill_tokarev.png",
	"./judges/samur_isma.png": "./app/assets/images/competitions/digital_art/judges/samur_isma.png",
	"./judges/stephen_price.png": "./app/assets/images/competitions/digital_art/judges/stephen_price.png",
	"./partners/bleank.png": "./app/assets/images/competitions/digital_art/partners/bleank.png",
	"./partners/boris_fx.png": "./app/assets/images/competitions/digital_art/partners/boris_fx.png",
	"./partners/celsys.png": "./app/assets/images/competitions/digital_art/partners/celsys.png",
	"./partners/escape_motions.png": "./app/assets/images/competitions/digital_art/partners/escape_motions.png",
	"./partners/fanurio_time_tracking.png": "./app/assets/images/competitions/digital_art/partners/fanurio_time_tracking.png",
	"./partners/huion.png": "./app/assets/images/competitions/digital_art/partners/huion.png",
	"./partners/lightwell.png": "./app/assets/images/competitions/digital_art/partners/lightwell.png",
	"./partners/marmoset.png": "./app/assets/images/competitions/digital_art/partners/marmoset.png",
	"./partners/media/80level.png": "./app/assets/images/competitions/digital_art/partners/media/80level.png",
	"./partners/media/andy_sowards.png": "./app/assets/images/competitions/digital_art/partners/media/andy_sowards.png",
	"./partners/media/concept_art_world.png": "./app/assets/images/competitions/digital_art/partners/media/concept_art_world.png",
	"./partners/media/freeyork.png": "./app/assets/images/competitions/digital_art/partners/media/freeyork.png",
	"./partners/nevercenter.png": "./app/assets/images/competitions/digital_art/partners/nevercenter.png",
	"./partners/paintable.png": "./app/assets/images/competitions/digital_art/partners/paintable.png",
	"./partners/pencilkings.png": "./app/assets/images/competitions/digital_art/partners/pencilkings.png",
	"./partners/stash_magazine.png": "./app/assets/images/competitions/digital_art/partners/stash_magazine.png",
	"./partners/tonytextures.png": "./app/assets/images/competitions/digital_art/partners/tonytextures.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/assets/images/competitions/digital_art sync recursive ^\\.\\/.*\\.png$";